import Vue from 'vue'
import Router from 'vue-router'

import { pageRouter } from './utils'
import { pages, adminpages } from './page'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
    else window.location.reload(true)
  });
}

Vue.use(Router)

export const router =  new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior(to, from, savedPosition) {
    return to.name != 'publication' || from.name != 'publication' || to.params.top ? { y: 0, behavior: 'smooth' } : {}
  },
  routes: pageRouter(pages)
})

export const adminrouter =  new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: pageRouter(adminpages)
})
